import React from "react";
import capitalize from "lodash/capitalize";
import PropTypes from "prop-types";
import validator from "validate.js";
import Checkbox from "components/elements/checkbox";
import SVG from "components/elements/svg";
import TextContent from "components/elements/text-content";
import ValidatedInput from "components/elements/validated-input";
import { CONFIRMATION_RULES } from "components/register/form.validation";

class Confirmation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      form: props.form,
      validationErrors: {},
    };
  }

  goBack() {
    this.props.onStepChange({
      step: 1,
      form: this.state.form,
      shouldCreate: false,
    });
  }

  handleSubmit() {
    const validationErrors = validator(this.state.form, CONFIRMATION_RULES);

    if (validationErrors) {
      this.setState({
        validationErrors,
      });

      return null;
    }

    this.props.onStepChange({
      step: 2,
      form: this.state.form,
      shouldCreate: true,
    });

    return null;
  }

  handleInputChange(e) {
    const form = { ...this.state.form, [e.target.name]: e.target.checked };

    this.setState({ form });
  }

  render() {
    const { form } = this.props;
    const { validationErrors } = this.state;

    return (
      <section className="register-confirmation">
        <div className="container">
          <h2 className="section-heading">Confirmation</h2>

          <TextContent>
            <p>
              Please check that your details below are correct. To edit click
              back, otherwise please proceed to the terms and conditions
              section.
            </p>
          </TextContent>

          <div className="register-confirmation__details">
            <div className="row">
              <div className="col-sm-6 col-table">
                <table>
                  <tbody>
                    <tr>
                      <td>Account type</td>
                      <td>{capitalize(form.accountType)}</td>
                    </tr>
                    <tr>
                      <td>Full name</td>
                      <td>
                        {form.firstName} {form.lastName}
                      </td>
                    </tr>
                    <tr>
                      <td>Date of birth</td>
                      <td>{`${form.birthDay}/${form.birthMonth}/${form.birthYear}`}</td>
                    </tr>
                    <tr>
                      <td>E-mail address</td>
                      <td>{form.email}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="col-sm-6 col-table">
                <table>
                  <tbody>
                    <tr>
                      <td>Address</td>
                      <td>
                        {form.address1}, {form.address2}
                      </td>
                    </tr>
                    <tr>
                      <td>City / Town</td>
                      <td>{form.city}</td>
                    </tr>
                    <tr>
                      <td>Postcode</td>
                      <td>{form.postCode}</td>
                    </tr>
                    <tr>
                      <td>Contact number</td>
                      <td>{`${form.phonePrefix} ${form.phone}`}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <h3 className="section-heading">Terms & Conditions</h3>

          <TextContent className="register-confirmation__terms">
            <p>
              Please confirm that you have read and accept our terms and
              conditions. Click{" "}
              <span className="text-medium">"create an account" </span>
              when ready.
            </p>

            <div>
              <ValidatedInput errors={validationErrors.acceptRules}>
                <Checkbox
                  label="I have read and accept the"
                  name="acceptRules"
                  onChange={(e) => this.handleInputChange(e)}
                  defaultChecked={form.acceptRules}
                />
                <span>
                  &nbsp;
                  <a
                    href={`/static/files/${form.accountType}-terms.pdf`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Terms & Conditions
                  </a>
                </span>
              </ValidatedInput>
            </div>
          </TextContent>

          <div className="register-confirmation__actions">
            <button
              className="btn btn-secondary with-arrow--reversed"
              onClick={() => this.goBack()}
            >
              <SVG src="arrow-left" className="arrow" />
              <span>Back</span>
            </button>

            <button
              className="btn btn-primary with-arrow"
              onClick={() => this.handleSubmit()}
            >
              <span>Create an account</span>
              <SVG src="arrow-right" className="arrow" />
            </button>
          </div>
        </div>
      </section>
    );
  }
}

Confirmation.propTypes = {
  form: PropTypes.shape({
    accountType: PropTypes.string.isRequired,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    birthDay: PropTypes.string.isRequired,
    birthMonth: PropTypes.string.isRequired,
    birthYear: PropTypes.string.isRequired,
    address1: PropTypes.string.isRequired,
    address2: PropTypes.string,
    city: PropTypes.string.isRequired,
    postCode: PropTypes.string.isRequired,
    phone: PropTypes.string.isRequired,
  }).isRequired,
  onStepChange: PropTypes.func.isRequired,
};

Confirmation.defaultProps = {
  address2: "",
};

export default Confirmation;
